import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useUserStore } from '@/stores/user/userStore';
import useEmailBannerStore from '@/stores/emailBanner/emailBannerStore';
import { trackBrEmailBannerShown } from '@/services/user.service';
import DModal from '@/components/Global/DModal';
import bannerText from '@/BannerText.md?raw';

// Banner is time-boxed: added 2026-08-07, remove this component and its
// wiring in LayoutShell after ~30 days live (around 2026-09-06).
const [subjectLine, ...bodyLines] = bannerText.trim().split('\n');
const EMAIL_SUBJECT = subjectLine.replace(/^Subject:\s*/i, '').trim();
const EMAIL_BODY = bodyLines.join('\n').trim();

const EmailBanner = () => {
  const showBanner = useUserStore((state) => state.user.show_br_email_banner);
  const setUser = useUserStore((state) => state.setUser);
  const isModalOpen = useEmailBannerStore((state) => state.isModalOpen);
  const openModal = useEmailBannerStore((state) => state.openModal);
  const closeModal = useEmailBannerStore((state) => state.closeModal);

  const handleReadMore = () => {
    openModal();
    // Mark as seen on the backend so show_br_email_banner comes back false
    trackBrEmailBannerShown().catch((error) => {
      console.error('Error tracking email banner read event:', error);
    });
  };

  const handleClose = () => {
    closeModal();
    setUser({ ...useUserStore.getState().user, show_br_email_banner: false });
  };

  if (!showBanner) return null;

  return (
    <>
      <div className="w-full bg-v3-orange-dark text-white px-v3-sm py-v3-xxs flex items-center justify-center gap-v3-xs text-sm text-center">
        <span className="font-medium truncate">{EMAIL_SUBJECT}</span>
        <button
          type="button"
          onClick={handleReadMore}
          className="underline font-semibold whitespace-nowrap hover:opacity-80 transition-opacity"
        >
          Read more
        </button>
      </div>

      <DModal
        isOpen={isModalOpen}
        onClose={handleClose}
        title={EMAIL_SUBJECT}
      >
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            p: ({ children }) => (
              <p className="mb-v3-ms last:mb-0 text-v3-black-secondary">{children}</p>
            ),
            strong: ({ children }) => (
              <strong className="font-semibold text-v3-black-max">{children}</strong>
            ),
            a: ({ children, href }) => (
              <a href={href} className="text-v3-purple-primary underline" target="_blank" rel="noreferrer">
                {children}
              </a>
            ),
          }}
        >
          {EMAIL_BODY}
        </ReactMarkdown>
      </DModal>
    </>
  );
};

export default EmailBanner;
